import { useEffect, type ReactNode } from "react";
import { useAuth } from "./AuthProvider";
import { getConfig } from "../config";
import { Spinner } from "../components/Spinner";

interface AuthGuardProps {
  children: ReactNode;
}

/**
 * Route wrapper that enforces authentication.
 * Redirects to Identity Server login if not authenticated.
 * When AUTH_ENABLED is false, passes children through (dev mode).
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading, login } = useAuth();
  const config = getConfig();

  useEffect(() => {
    if (!config.AUTH_ENABLED) return;
    if (!isLoading && !isAuthenticated) {
      sessionStorage.setItem("preLoginUrl", window.location.pathname + window.location.search);
      login();
    }
  }, [isLoading, isAuthenticated, login, config.AUTH_ENABLED]);

  if (!config.AUTH_ENABLED) return <>{children}</>;
  if (isLoading || !isAuthenticated) return <Spinner overlay />;

  return children;
}
